/**
 * Created by lycheng on 2017/12/4.
 * 所有service都需要引入
 */
import 'js/libs/common'
import { suspension } from 'js/libs/utils-suspension'
import { floatMenu } from 'js/libs/utils-topbar-menu'
import { config } from 'config'
import { addCurrentPageParams, toUrl } from 'js/libs/utils'

function bindEvent () {
  // banner下立即申请
  $('.banner-to-service-manage').click(function () {
    let serviceKey = this.dataset.serviceKey
    toUrl(`${config.CONSOLE}services/${serviceKey}`, '_blank')
  })
  $('.banner-apply-btn').click(function () {
    var $this = $(this)
    var href = addCurrentPageParams($this.data('href'))
    toUrl(href, '_blank')
  })
}

function init () {
  suspension()
  bindEvent()
}
init()



// WEBPACK FOOTER //
// ./src/js/libs/utils-solutions.js